// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

const landingPageHeroUnit = require("../../../../Assets/images/landing-page/landing-page-herounit-lead-01.png");
type PropsType = {
  translate: string => void
};

type StateType = {};

class HeroUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <header className="header text-white h-fullscreen landing-page-header-area">
        <div className="container">
          <div className="row align-items-center h-100">
            <div className="col-md-5">
              <h1>{translate("LandingPageLocale.hero_unit.header")}</h1>
              <p className="lead mt-5 mb-8">{translate("LandingPageLocale.hero_unit.content")}</p>
              <Link to="/kayit-ol" className="btn btn-round btn-light w-250 ml-3">
                {translate("LandingPageLocale.hero_unit.register_action")}
              </Link>
            </div>

            <div className="col-md-6 ml-auto">
              <img src={landingPageHeroUnit} alt="landing-page-hero-unit" />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default HeroUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/LandingPage/HeroUnit.js